import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { About } from './components/About';
import { WhyChooseUs } from './components/WhyChooseUs';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-slate-50 font-sans selection:bg-accent/30 selection:text-primary" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Services data-id="element-4" />
        <About data-id="element-5" />
        <WhyChooseUs data-id="element-6" />
        <Contact data-id="element-7" />
      </main>
      <Footer data-id="element-8" />
    </div>;
}